import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader
} from '../../components/other/card/card'
import CampaignDropdown from '../../components/CampaignDropdown'
import { useGetServicesQuery } from '../../redux/apis/servicesManagement/sMServicesApiSlice'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useCreateSourceMutation } from '../../redux/apis/linkManagement/ugc/lMUgcSourceApiSlice'
import TextArea from 'antd/es/input/TextArea'
import { Input } from 'antd'
import Loader from '../pages/loader'
import InsertionResultModal from '../../components/InsertionResultModal'

const CyberlockerInsertion = React.memo(() => {
  const context = useContext(AppSettings)
  const [create, { isLoading }] = useCreateSourceMutation()
  const [result, setResult] = useState(null)
  const { data: servicesData } = useGetServicesQuery({
    fields: ['id', 'service_name'],
    page: '*',
    is_active: true
  })

  const cyberlockerServiceId = servicesData?.data?.results?.find(
    s => s.service_name?.toLowerCase() === 'ugc-source'
  )?.id

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      campaign: '',
      urls: '',
      link_keyword: ''
    },

    validationSchema: Yup.object({
      urls: Yup.string().required('Please Enter Urls'),
      campaign: Yup.number().required('Please Enter Campaign '),
      link_keyword: Yup.string()
    }),

    onSubmit: async values => {
      const urls = values.urls
        .split('\n')
        .map(url => url.trim())
        .filter(url => url)

      const data = urls.map(url => ({
        campaign: values.campaign,
        url: url,
        service: cyberlockerServiceId,
        is_related: true,
        review_date: new Date().toISOString().split('T')[0],
        crawl_date: new Date().toISOString().split('T')[0],
        ...(values.link_keyword ? { link_keyword: values.link_keyword } : {})
      }))

      try {
        const res = await create(data)
        const resultData = res?.data ?? res?.error?.data ?? {}
        setResult(resultData)
        if (res?.data?.success) {
          validation.resetForm()
        }
      } catch (error) {
        console.error(error)
      }
    }
  })

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  return (
    <div>
      <Loader isLoading={isLoading} />
      <InsertionResultModal
        result={result}
        reportTitle='Cyberlocker URL insertion'
        onClose={() => setResult(null)}
      />
      <Card>
        <CardHeader>
          <p>Cyberlocker Link Insertion</p>
        </CardHeader>
        <CardBody>
          {cyberlockerServiceId ? (
            <CampaignDropdown
              onBlur={validation.handleBlur}
              onChange={e => {
                validation.setFieldValue('campaign', e)
              }}
              status="active"
              value={validation.values?.campaign}
              service_id={cyberlockerServiceId}
              className='customSelect'
            />
          ) : (
            <div className='mb-3'>
              <label className="form-label">Campaign</label>
              <br />
              <div className='customSelect' style={{ height: 38, background: '#f5f5f5', borderRadius: 6 }} />
            </div>
          )}
          {validation.touched.campaign && validation.errors.campaign ? (
            <p className='text-danger'>{validation.errors.campaign}</p>
          ) : null}
          <div className='mb-3 flex-1 customInput'>
            <label className='form-label'>Keyword</label>
            <Input
              type='text'
              name='link_keyword'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.link_keyword}
              placeholder='Enter keyword (optional)'
            />
          </div>
          <div className=' mb-3 flex-1 customInput'>
            <label className="form-label">URLs (separated by new lines)</label>
            <TextArea
              type='text'
              name='urls'
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.urls}
              placeholder='Enter urls separated by new lines
              example:
              test.com
              test2.com
              test3.com
              '
              rows={15}
            />
            {validation.touched.urls && validation.errors.urls ? (
              <p className='text-danger'>{validation.errors.urls}</p>
            ) : null}
          </div>
        </CardBody>
        <CardFooter>
          <div className='flex justify-end gap-8'>
            <button
              onClick={() => {
                validation.handleSubmit()
              }}
              className='btn btn-theme'
            >
              Submit
            </button>
          </div>
        </CardFooter>
      </Card>
    </div>
  )
})

export default CyberlockerInsertion
